// Autogenerated file
export const accessPermitRelationTypesEnum = {
    NoRelation: "NoRelation",
    Car: "Car",
    Driver: "Driver",
    Trailer: "Trailer",
};
export const accessPermitRelationTypes = [
    { label: "Без связи", value: "NoRelation" },
    { label: "Машина", value: "Car" },
    { label: "Водитель", value: "Driver" },
    { label: "Прицеп", value: "Trailer" },
];
